import { AxiosResponse } from 'axios';
import { ReactElement, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate } from 'react-router-dom';
// import * as Sentry from '@sentry/browser';

import request from 'app/utils/request';
import { Loading } from 'components';
import { AuthApiResponse, useAuth } from 'features/auth';
import { useSchool } from 'features/school';

import { PrivateRouteProps } from './types';

const PrivateRoute = ({ children, redirectIfNotLogged = true }: PrivateRouteProps): ReactElement => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const { isLogged } = useAuth();
  const { setAuth, setRedirectUrl, setLoginChecked, loginChecked } = useAuth();
  const { apiGatewayUrl } = useSchool();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(['token']);

  useEffect(() => {
    if (apiGatewayUrl && !isLogged) {
      const tokenFromCookie = cookies.token;

      const removeToken = () => {
        setRedirectUrl(`${pathname}${search}`);
        removeCookie('token', {
          path: '/',
          domain: window.location.hostname,
        });
        setLoginChecked(true);

        if (redirectIfNotLogged) navigate('/login');
      };

      if (tokenFromCookie) {
        request({
          url: '/api/v1/User/Check',
          method: 'get',
          baseURL: apiGatewayUrl,
        })
          .then((response: AxiosResponse<AuthApiResponse>) => {
            const { roles } = response.data;

            const roleIsStudent = roles.find((role) => role.name === 'Student');

            if (roleIsStudent) {
              // Sentry.setUser({ id: studentUuid });

              // if (window.octadesk) {
              //   window.octadesk.chat.login({
              //     user: {
              //       name: fullName,
              //       email: loginEmail,
              //     },
              //     customFields: [
              //       {
              //         id: 'customerUuid',
              //         value: customerUuid,
              //       },
              //     ],
              //   });
              // }

              setAuth(response.data);
            } else {
              removeToken();
            }
          })
          .catch(removeToken);
      } else {
        setLoginChecked(true);

        if (redirectIfNotLogged) {
          setRedirectUrl(`${pathname}${search}`);
          navigate('/login');
        }
      }
    } else {
      setLoginChecked(true);
    }
  }, [apiGatewayUrl]);

  return (isLogged || !redirectIfNotLogged) && loginChecked ? (
    <>{children}</>
  ) : (
    <>
      <Loading label="Por favor, aguarde." />
    </>
  );
};

export default PrivateRoute;
